/** How charts show the user-configured reference lines; a per-browser viewer setting. */
export type ReferenceLinesMode = 'off' | 'lines' | 'linesWithLabels';

export const DEFAULT_REFERENCE_LINES_MODE: ReferenceLinesMode = 'linesWithLabels';

const NEXT_REFERENCE_LINES_MODE: Record<ReferenceLinesMode, ReferenceLinesMode> = {
  linesWithLabels: 'off',
  off: 'lines',
  lines: 'linesWithLabels',
};

export function isReferenceLinesMode(value: unknown): value is ReferenceLinesMode {
  return typeof value === 'string' && Object.hasOwn(NEXT_REFERENCE_LINES_MODE, value);
}

/** The toggle cycles Lines with labels > Off > Lines > Lines with labels. */
export function getNextReferenceLinesMode(mode: ReferenceLinesMode): ReferenceLinesMode {
  return NEXT_REFERENCE_LINES_MODE[mode];
}
